import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `
  <div>
    <h3>***RESOLUTION SOP FOR EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC***</h3>
    <ol>
      <li>Check if DP proactively reaches out.
        <ol>
          <li>Yes → Move to step 2</li>
          <li>No → LM POC Calls DP</li>
        </ol>
      </li>
      <li>Check if it's the 1st Exception within Block.
        <ol>
          <li>Yes → LM POC will warn DP, then unblock DP</li>
          <li>No → Move to step 3</li>
        </ol>
      </li>
      <li>LM POC Calls DP (if not already done in step 1)</li>
      <li>Check if DP Picks Call.
        <ol>
          <li>Yes → Move to step 5</li>
          <li>No → Discharge with right reason code</li>
        </ol>
      </li>
      <li>If DP disputes, DP will be advised by LM POC to Contact SDS</li>
    </ol>
    <p>
      Note: CO will deep dive on all Discharge / Unblock exceptions at D-1 to highlight any DP / Site level abuse trends. CO will then work with Flex, Ops teams to design better mechanisms to reduce those abuse MOs.
    </p>
    <p>For more generic details, please visit: <a href="https://w.amazon.com/bin/view/Stratos/Internal/MBEDashboard/ExceptionSOP/EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC/">Wiki</a></p>
    <p>For more AE related details, please visit: <a href="https://w.amazon.com/bin/view/Stratos/Internal/MBEDashboard/ExceptionSOP/AE_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC/">Wiki</a></p>
    <p>For more UK related details, please visit: <a href="https://w.amazon.com/bin/view/Stratos/Internal/MBEDashboard/ExceptionSOP/UK_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC/">Wiki</a></p>
  </div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/EU_QC_FLEX_DP_OFFER_NON_ACK_VIOLATION_SCC.jsx